import { create } from "zustand";
import * as SharedMessageTypes from "../../darvin-shared/schema/zod/agent/message-types.schema";
import { useProjectStore } from "../core_stores/useProjectStore";

interface RollbackHandlerActions {
  startRollback: (checkpointId: string) => void;
  rollbackConfirmed: () => void;
  reset: () => void;
}

interface RollbackHandlerState {
  checkpointId: string | null;
  shouldConfirmRollback: boolean;

  actions: RollbackHandlerActions;
}

const useRollbackHandlerStore = create<RollbackHandlerState>((set, get) => {
  return {
    checkpointId: null,
    shouldConfirmRollback: false,

    actions: {
      startRollback: (checkpointId: string) => {
        set({ shouldConfirmRollback: true, checkpointId });
      },

      rollbackConfirmed: () => {
        const unsubscribe = useProjectStore.subscribe(
          (state) => state.latestMsg,
          (latestMsg) => {
            if (
              latestMsg?.type ===
              SharedMessageTypes.MessageTypeEnum.Enum.jobDone
            ) {
              unsubscribe();
              set({ checkpointId: null });
              set({ shouldConfirmRollback: false });
            }
          }
        );
        useProjectStore.getState().actions.rollback(get().checkpointId!);
      },

      reset: () => {
        set({ shouldConfirmRollback: false, checkpointId: null });
      },
    },
  };
});

export const useShouldConfirmRollback = () =>
  useRollbackHandlerStore((state) => state.shouldConfirmRollback);

export const useRollbackHandlerActions = () =>
  useRollbackHandlerStore((state) => state.actions);
